// import React, { useState, useEffect } from "react";
// import { doc, setDoc, getDoc } from "firebase/firestore";
// import { db } from "../firebase";
// import { getAuth, onAuthStateChanged } from "firebase/auth";
// import SevakForm from "./ttdSeva";

// const generateGroupAccountId = () => {
//   const now = new Date();
//   const yymmdd = now.toISOString().slice(2, 10).replace(/-/g, "");
//   const randomNumber = Math.floor(1000 + Math.random() * 9000);
//   return yymmdd + randomNumber;
// };

// const GroupWithSevakForm = () => {
//   const [showGroupForm, setShowGroupForm] = useState(false);
//   const [groupData, setGroupData] = useState(null);
//   const [newGroup, setNewGroup] = useState({
//     groupName: "",
//     leaderName: "",
//     location: "",
//     mobile: "",
//   });
//   const [user, setUser] = useState(null);
//   const [userProfile, setUserProfile] = useState(null);

//   useEffect(() => {
//     const auth = getAuth();
//     const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
//       if (currentUser) {
//         setUser(currentUser);
//         const userRef = doc(db, "users", currentUser.uid);
//         const userSnap = await getDoc(userRef);
//         if (userSnap.exists()) {
//           setUserProfile(userSnap.data());
//         }
//       } else {
//         setUser(null);
//         setUserProfile(null);
//       }
//     });

//     return () => unsubscribe();
//   }, []);

//   const handleGroupChange = (e) => {
//     const { name, value } = e.target;
//     setNewGroup((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleCreateGroup = async () => {
//     if (!user || !userProfile) {
//       alert("You must be logged in to create a group.");
//       return;
//     }

//     const { role, accountId } = userProfile;
//     if (!["admin", "agent"].includes(role) || !accountId) {
//       alert("Only admins or agents with a valid account ID can create groups.");
//       return;
//     }

//     try {
//       const groupId = generateGroupAccountId();
//       const groupPayload = {
//         ...newGroup,
//         accountId: groupId,
//         createdAt: new Date(),
//         members: [],
//         createdBy: {
//           uid: user.uid,
//           role,
//           accountId,
//         },
//       };

//       const groupRef = doc(db, "sevakGroups", groupId);
//       await setDoc(groupRef, groupPayload);

//       const docSnap = await getDoc(groupRef);
//       setGroupData({ ...docSnap.data(), id: groupRef.id });
//       setShowGroupForm(false);
//     } catch (error) {
//       console.error("Error creating group:", error);
//       alert("Failed to create group");
//     }
//   };

//   const handleSevakAdded = (sevakData) => {
//     setGroupData((prev) => ({
//       ...prev,
//       members: [...(prev?.members || []), sevakData],
//     }));
//   };

//   return (
//     <div className="container mt-4">
//       {!groupData && (
//         <div className="text-center mb-3">
//           {!showGroupForm ? (
//             <button
//               className="btn btn-success"
//               onClick={() => setShowGroupForm(true)}
//             >
//               Add New Group
//             </button>
//           ) : (
//             <div className="card p-3">
//               <h5 className="mb-3">Create New Group</h5>
//               <div className="row g-3">
//                 <div className="col-md-6">
//                   <label className="form-label">Group Name</label>
//                   <input
//                     type="text"
//                     name="groupName"
//                     className="form-control"
//                     value={newGroup.groupName}
//                     onChange={handleGroupChange}
//                     required
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Leader Name</label>
//                   <input
//                     type="text"
//                     name="leaderName"
//                     className="form-control"
//                     value={newGroup.leaderName}
//                     onChange={handleGroupChange}
//                     required
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Location</label>
//                   <input
//                     type="text"
//                     name="location"
//                     className="form-control"
//                     value={newGroup.location}
//                     onChange={handleGroupChange}
//                     required
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Mobile</label>
//                   <input
//                     type="text"
//                     name="mobile"
//                     className="form-control"
//                     value={newGroup.mobile}
//                     onChange={handleGroupChange}
//                     required
//                   />
//                 </div>
//               </div>
//               <div className="text-center mt-3">
//                 <button className="btn btn-primary" onClick={handleCreateGroup}>
//                   Save Group
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>
//       )}

//       {groupData && (
//         <>
//           <div className="card p-3 mb-4 bg-light">
//             <h5>Group Details</h5>
//             <p>
//               <strong>Group Name:</strong> {groupData.groupName}
//             </p>
//             <p>
//               <strong>Leader:</strong> {groupData.leaderName}
//             </p>
//             <p>
//               <strong>Location:</strong> {groupData.location}
//             </p>
//             <p>
//               <strong>Mobile:</strong> {groupData.mobile}
//             </p>
//             <p>
//               <strong>Group Account ID:</strong> {groupData.accountId}
//             </p>
//           </div>

//           <SevakForm
//             groupId={groupData.id}
//             groupData={groupData}
//             onSevakAdded={handleSevakAdded}
//           />
//         </>
//       )}
//     </div>
//   );
// };

// export default GroupWithSevakForm;
// ==================================================
import React, { useState, useEffect } from "react";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import SevakForm from "./ttdSeva";

const generateGroupAccountId = () => {
  const now = new Date();
  const yymmdd = now.toISOString().slice(2, 10).replace(/-/g, "");
  const randomNumber = Math.floor(1000 + Math.random() * 9000);
  return yymmdd + randomNumber;
};

const GroupWithSevakForm = () => {
  const [showGroupForm, setShowGroupForm] = useState(false);
  const [groupData, setGroupData] = useState(null);
  const [newGroup, setNewGroup] = useState({
    groupName: "",
    leaderName: "",
    location: "",
    mobile: "",
  });
  const [user, setUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        const userRef = doc(db, "users", currentUser.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          setUserProfile(userSnap.data());
        }
      } else {
        setUser(null);
        setUserProfile(null);
      }
    });

    return () => unsubscribe();
  }, []);

  const handleGroupChange = (e) => {
    const { name, value } = e.target;
    setNewGroup((prev) => ({ ...prev, [name]: value }));
  };

  const handleCreateGroup = async () => {
    if (!user || !userProfile) {
      alert("You must be logged in to create a group.");
      return;
    }

    const { role, accountId } = userProfile;
    if (!["admin", "agent"].includes(role) || !accountId) {
      alert("Only admins or agents with a valid account ID can create groups.");
      return;
    }

    try {
      const groupId = generateGroupAccountId();
      const groupPayload = {
        ...newGroup,
        accountId: groupId,
        createdAt: new Date(),
        members: [],
        createdBy: {
          uid: user.uid,
          role,
          accountId,
        },
      };

      const groupRef = doc(db, "sevakGroups", groupId);
      await setDoc(groupRef, groupPayload);

      const docSnap = await getDoc(groupRef);
      setGroupData({ ...docSnap.data(), id: groupRef.id });
      setShowGroupForm(false);
    } catch (error) {
      console.error("Error creating group:", error);
      alert("Failed to create group");
    }
  };

  const handleSevakAdded = (sevakData) => {
    setGroupData((prev) => ({
      ...prev,
      members: [...(prev?.members || []), sevakData],
    }));
  };

  return (
    <div className="container mt-4">
      {!groupData && (
        <div className="text-center mb-3">
          {!showGroupForm ? (
            <button
              className="btn btn-success"
              onClick={() => setShowGroupForm(true)}
            >
              Add New Group
            </button>
          ) : (
            <div className="card p-3">
              <h5 className="mb-3">Create New Group</h5>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Group Name</label>
                  <input
                    type="text"
                    name="groupName"
                    className="form-control"
                    value={newGroup.groupName}
                    onChange={handleGroupChange}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Leader Name</label>
                  <input
                    type="text"
                    name="leaderName"
                    className="form-control"
                    value={newGroup.leaderName}
                    onChange={handleGroupChange}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Location</label>
                  <input
                    type="text"
                    name="location"
                    className="form-control"
                    value={newGroup.location}
                    onChange={handleGroupChange}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Mobile</label>
                  <input
                    type="text"
                    name="mobile"
                    className="form-control"
                    value={newGroup.mobile}
                    onChange={handleGroupChange}
                    required
                  />
                </div>

                <div className="col-md-6">
  <label className="form-label">Image Folder Path</label>
  <input
    type="text"
    name="imageFolderPath"
    className="form-control"
    value={newGroup.imageFolderPath}
    onChange={handleGroupChange}
    placeholder="e.g., C:/Users/You/Pictures/sevakGroup1"
    required
  />
</div>



              </div>
              <div className="text-center mt-3">
                <button className="btn btn-primary" onClick={handleCreateGroup}>
                  Save Group
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {groupData && (
        <>
          <div className="card p-3 mb-4 bg-light">
            <h5>Group Details</h5>
            <p>
              <strong>Group Name:</strong> {groupData.groupName}
            </p>
            <p>
              <strong>Leader:</strong> {groupData.leaderName}
            </p>
            <p>
              <strong>Location:</strong> {groupData.location}
            </p>
            <p>
              <strong>Mobile:</strong> {groupData.mobile}
            </p>
            <p>
              <strong>Group Account ID:</strong> {groupData.accountId}
            </p>
            <p>
              <strong>ImagePath:</strong> {groupData.imageFolderPath}
            </p>
          </div>

          <SevakForm
            groupId={groupData.id}
            groupData={groupData}
            onSevakAdded={handleSevakAdded}
          />
        </>
      )}
    </div>
  );
};

export default GroupWithSevakForm;
